import React, { useState } from "react";

import Profile from "./Profile";
import Accounts from "./Accounts";

import Flex from "../Components/Flex";
import Card from "../Components/Card";
import Button from "../Components/Button";
import Flyout from "../Components/Flyout";
import profilePic from "../static/pic.png";
import ProfilePicture from "../Components/ProfilePicture";

const Home: React.FC = () => {
  const [AccountflyoutOpen, setAccountFlyoutOpen] = useState(false);
  const [SettingsflyoutOpen, setSettingsFlyoutOpen] = useState(false);

  const toggleAccountsFlyout = () => {
    setAccountFlyoutOpen(!AccountflyoutOpen);
  };

  const toggleSettingsFlyout = () => {
    setSettingsFlyoutOpen(!SettingsflyoutOpen);
  };

  return (
    <>
      <Flex $justify="space-between">
        <Flex $alignItems="flex-start">
          <Button title="Accounts" icon="FaCreditCard" onClick={toggleAccountsFlyout} />
        </Flex>
        <div onClick={toggleSettingsFlyout}>
          <ProfilePicture altText="profilePic" imageUrl={profilePic} />
        </div>
      </Flex>
      <Flex $direction="column">
        <Card title="test" />
      </Flex>
      <Flyout title="Bank accounts" isOpen={AccountflyoutOpen} onClose={toggleAccountsFlyout}>
        {AccountflyoutOpen && <Accounts />}
      </Flyout>
      <Flyout title="Settings" isOpen={SettingsflyoutOpen} onClose={toggleSettingsFlyout}>
        {SettingsflyoutOpen && <Profile />}
      </Flyout>
    </>
  );
};

export default Home;
